import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import { JobApplicationStatuses } from '@/constants/job/jobApplicationStatuses'
import { RootState } from '@/store'

export default Vue.extend({
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.jobChat.application.value,
    }),
    ...mapGetters({
      room: 'chatNew/getOpenedRoom',
    }),
    isLocked() {
      return this.room && !this.room.isUnlocked
    },
    isStarted() {
      return this.application?.wasStarted
    },
    isArchived() {
      return this.application.status === JobApplicationStatuses.ARCHIVED
    },
    hasViewInvoice() {
      return !!this.application.job.invoiceUrl
    },
  },
})
